<template>
  <div>
    <h2>Payments</h2>
    <form @submit.prevent="submit">
      <div>
        <label>Client</label><br>
        <select v-model="form.clientId" required>
          <option value="">-- choose client --</option>
          <option v-for="c in clients" :key="c.id" :value="c.id">{{ c.name }}</option>
        </select>
      </div>
      <div>
        <label>Amount</label><br>
        <input type="number" step="0.01" v-model.number="form.amount" required />
      </div>
      <div>
        <label>Date</label><br>
        <input type="date" v-model="form.date" />
      </div>
      <div>
        <label>Method</label><br>
        <input v-model="form.method" placeholder="cash/card" />
      </div>
      <div style="margin-top:8px">
        <button type="submit" class="btn btn-success"><i class="bi bi-credit-card me-1"></i>Save Payment</button>
      </div>
    </form>

    <h3 style="margin-top:16px">Payments</h3>
    <table v-if="payments.length" border="1" cellpadding="6">
      <thead><tr><th>Client</th><th>Amount</th><th>Date</th><th>Method</th></tr></thead>
      <tbody>
        <tr v-for="p in payments" :key="p.id">
          <td>{{ clientName(p.clientId) }}</td>
          <td>{{ p.amount }}</td>
          <td>{{ p.date }}</td>
          <td>{{ p.method }}</td>
        </tr>
      </tbody>
    </table>
    <p v-else>No payments recorded.</p>
  </div>
</template>

<script>
import store from '../store/localStore'

export default {
  name: 'PaymentsView',
  data() {
    return {
      clients: [],
      payments: [],
      form: { clientId: '', amount: 0, date: '', method: '' }
    }
  },
  created() { this.load() },
  methods: {
    load() {
      this.clients = store.getClients()
      this.payments = store.getPayments().slice().reverse()
    },
    submit() {
      if (!this.form.clientId) return alert('Choose a client')
      store.savePayment({ clientId: this.form.clientId, amount: this.form.amount, date: this.form.date || new Date().toISOString().slice(0,10), method: this.form.method })
      this.form = { clientId: '', amount: 0, date: '', method: '' }
      this.load()
    },
    clientName(id) {
      const c = store.getClientById(id) || { name: 'Unknown' }
      return c.name
    }
  }
}
</script>

<style scoped>
form div { margin-bottom: 8px }
</style>
